import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-wa-main',
	templateUrl:'./WaMainPluginCompPage.html',
	styles: [],
	styleUrls:['./WaMainPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaMainPluginCompPage
{
	mdContent_1138 = `\`\`\`java
import com.jwebmp.webawesomepro.WaMain;
\`\`\``;
	mdContent_1139 = `\`\`\`java
new WaMain&lt;&gt;()
\`\`\``;
}
